import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { Discount } from './discount';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { DiscountType } from '../types';
import { ProductType } from '../types';

const _schema = {
    "name": "DISCOUNTPRODUCT",
    "fields": [
        { name: "status", type: "string", default: "AC" },
        { name: "discount", type: "objid" },
        { name: "product", type: "objid" }
    ],
    relate: [
        { direction: ">", target: "DISCOUNT", by: "discount", name: "discount", reason: "discount", child: false, class: DiscountType },
        { direction: ">", target: "PRODUCT", by: "product", name: "product", reason: "product", child: false, class: ProductType }
    ]
} as const;

const _DiscountProductClass = CreateObject(_schema);
if (!_DiscountProductClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class DiscountProduct extends _DiscountProductClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): DiscountProduct {
        return this._Copy(store) as DiscountProduct;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'discount' && related instanceof Discount){
            if (related === this.discount){
                related.AddProduct(this);
            }
        }
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/

    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.discount){
            if ((this.status == 'DE') && !this.Commited){
                this.discount.DelProduct(this);
            }
            else {
                this.discount.DoRefresh(this.table);
            }    
        }
    }

    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        if (!this.product){
            return false;
        }

        let _isvalid = (!!this.status && (this.status != 'DE'));
        
        if (_isvalid && this.product){
            _isvalid = this.product.IsValid || false;
        }

        return _isvalid;
    }    
}

